import React, { useState } from "react";
import ReactSlider from "react-slider";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 250px;
`;

const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  aspect-ratio: 1;
  font-size: 16px;
  color: #5e6366;
  margin-bottom: 4px;
`;

const StyledSlider = styled(ReactSlider)`
  flex: 1;
  height: 4px;
  margin: 0 12px;
  background: #e0e0e0;
  border-radius: 4px;
`;

const Thumb = styled.div`
  height: 16px;
  aspect-ratio: 1;
  background: white;
  border-radius: 50%;
  border: 2px solid #ccc;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  cursor: grab;
  margin-top: -6px;
`;

const Track = styled.div`
  top: 0;
  bottom: 0;
  background: #d1d1d1;
  border-radius: 4px;
`;

export const Slider = ({ $setMultiple = () => undefined, $multiple }) => {
  return (
    <Container>
      <Label>−</Label>
      <StyledSlider
        value={$multiple}
        onChange={$setMultiple}
        renderThumb={(props, state) => {
          const { key, ...rest } = props;
          return <Thumb key={key} {...rest} />;
        }}
        renderTrack={(props, state) => {
          const { key, ...rest } = props;
          return <Track key={key} {...rest} />;
        }}
        min={1}
        max={10}
      />
      <Label>+</Label>
    </Container>
  );
};
